<mad-data-table
  [filterMode]="'NONE'"
  [displayedColumns]="displayedColumns"
  [tableData]="tableData"
  [paginationEnabled]="paginationEnabled"
  [pageSizeOptions]="[5, 10, 15]"
  [defaultPageSize]="10"
  [rowExpandable]="rowExpandable"
>
  <ng-container madExpandableColumnDef="additionalData">
    <div *madExpandableCellDef="let element" class="expanded-row">
      <p>additional data</p>
      <ul>
        @for (entry of element.additionalData; track entry) {
          <li>{{ entry }}</li>
        }
      </ul>
    </div>
  </ng-container>
</mad-data-table>
